export const GR = () => {
  return (
    <>
      <g clipPath="url(#clip0_1073_11539)">
      <g clipPath="url(#clip1_1073_11539)">
      <rect width="48" height="48" fill="#0066FF"/>
      <rect x="48" width="48" height="16" fill="#0066FF"/>
      <rect x="48" y="32" width="48" height="16" fill="#0066FF"/>
      <rect y="64" width="96" height="16" fill="#0066FF"/>
      <rect x="48" y="16" width="48" height="16" fill="white"/>
      <rect y="16" width="48" height="16" fill="white"/>
      <rect x="16" y="48" width="48" height="16" transform="rotate(-90 16 48)" fill="white"/>
      <rect y="48" width="96" height="16" fill="white"/>
      <rect y="80" width="96" height="16" fill="white"/>
      </g>
      </g>
      <rect x="2" y="2" width="92" height="92" rx="46" stroke="white" strokeOpacity="0.15" strokeWidth="4"/>
      <defs>
      <clipPath id="clip0_1073_11539">
      <rect width="96" height="96" rx="48" fill="white"/>
      </clipPath>
      <clipPath id="clip1_1073_11539">
      <rect width="96" height="96" rx="24" fill="white"/>
      </clipPath>
      </defs>
    </>
  )
}
